import { NavLink } from 'react-router-dom';
import {
  ButtonPseudo,
  ButtonSize,
  ClickOutsideDetector,
  IconDown,
  IconExpand,
  IconUp,
  PermissionEnum,
} from '@ui/src';
import { TopContentTypes } from '../types';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';
import commonStyles from '../../../common/common.module.css';

const TopContent = ({
  search,
  selectedLists,
  activePermissions,
  updateSelectedListVisible,
  setUpdateSelectedListVisible,
  setPopupVisible,
  setAction,
  updateAllListVisible,
  setUpdateAllListVisible,
}: TopContentTypes) => (
  <div className={cn.clientsTop}>
    <NavLink
      to={`${ROUTES.CUSTOMERS_INDIVIDUAL_CREATE}${search || ''}`}
      className={commonStyles.customersCreateLink}
    >
      <div className={commonStyles.customersCreateLinkContent}>
        <IconExpand className={commonStyles.customersCreateLinkIcon} />
        <span>Create new customer</span>
      </div>
    </NavLink>

    {selectedLists.length > 0 &&
      activePermissions?.includes(
        PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_RISK_ACTION,
      ) && (
        <>
          <div className={cn.clientsTopSeparator} />
          <div
            className={`${cn.clientsUpdateWrapper} ${
              updateSelectedListVisible ? cn.clientsUpdateWrapperActive : ''
            }`}
          >
            <ClickOutsideDetector
              setOptionsListVisible={setUpdateSelectedListVisible}
              className={cn.clientsUpdateContent}
            >
              <>
                <ButtonPseudo
                  className={`button-white ${cn.updateClientsButton}`}
                  size={ButtonSize.SMALL}
                  text={`Update risk score for ${selectedLists?.length} customer${
                    selectedLists?.length > 1 ? 's' : ''
                  }`}
                  onClick={() =>
                    setUpdateSelectedListVisible(!updateSelectedListVisible)
                  }
                />
                {updateSelectedListVisible ? <IconUp /> : <IconDown />}
                {updateSelectedListVisible && (
                  <ul className={cn.updateOptionList}>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('updateSelected');
                        }}
                      >
                        Update calculated risk score
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('applySelected');
                        }}
                      >
                        Apply calculated risk score
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('updateAndApplySelected');
                        }}
                      >
                        Update and apply calculated risk score
                      </button>
                    </li>
                  </ul>
                )}
              </>
            </ClickOutsideDetector>
          </div>
          <div
            className={`${cn.clientsUpdateWrapper} ${
              updateAllListVisible ? cn.clientsUpdateWrapperActive : ''
            }`}
          >
            <ClickOutsideDetector
              setOptionsListVisible={setUpdateAllListVisible}
              className={cn.clientsUpdateContent}
            >
              <>
                <ButtonPseudo
                  className={`button-white ${cn.updateClientsButton}`}
                  size={ButtonSize.SMALL}
                  text="Update risk score for all customers"
                  onClick={() => setUpdateAllListVisible(!updateAllListVisible)}
                />
                {updateAllListVisible ? <IconUp /> : <IconDown />}
                {updateAllListVisible && (
                  <ul className={cn.updateOptionList}>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('updateAll');
                        }}
                      >
                        Update calculated risk score
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('applyAll');
                        }}
                      >
                        Apply calculated risk score
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setPopupVisible(true);
                          setAction('updateAndApplyAll');
                        }}
                      >
                        Update and apply calculated risk score
                      </button>
                    </li>
                  </ul>
                )}
              </>
            </ClickOutsideDetector>
          </div>
        </>
      )}
  </div>
);

export default TopContent;
